import React, {
  useRef,
  useState,
  useEffect,
  useContext,
  ChangeEvent,
} from 'react'
import axios from 'axios'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  InputRowDiv,
  InputDiv,
  InputLabel,
  Input,
  SwitchesDiv,
  SwitchDiv,
  SwitchLabel,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  FilesDiv,
  FileBlockDiv,
  FileHeaderText,
  FileInputDiv,
  FileInputLabel,
  FileInput,
  FilesInfoDiv,
  FileInfoDiv,
  FileInfoImg,
  FileMiddleDiv,
  FileUpperMiddleDiv,
  FileName,
  FilePercentage,
  FileInfoCancelImg,
  ProgressContainer,
  ProgressFill,
  FileFirstText,
  FileSecondText,
  ButtonsDiv,
  WarningDiv,
  WarningText,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import StockContext from '../../../../contexts/StockContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowLeft from '../../../../assets/addStockModal/pages/arrow-left.svg'
import fileIcon from '../../../../assets/addStockModal/pages/file.svg'
import cancelIcon from '../../../../assets/addStockModal/pages/cancel.svg'
import diskIcon from '../../../../assets/addStockModal/pages/disk.svg'
import StockDropdown from '../StockDropdown'
import SectionContext from '../../../../contexts/SectionContext'
import {
  FieldsToHeaders,
  fieldsToHeaders,
  StockInterface,
} from '../../../../pages/ClientPanel/Stock/StockTable/utils'
import UserContext from '../../../../contexts/UserContext'
import { Info } from 'lucide-react'

export interface ProgressBar {
  completion: number
}

const ThirdCustomAddPage: React.FC = () => {
  const { setModalActive, setModalSection, itIsUpdate } =
    useContext(ModalContext)
  const { stock, setStock } = useContext(StockContext)
  const { token } = useContext(UserContext)
  const [activeMenu, setActiveMenu] = useState(0)
  const [updateInOmie, setUpdateInOmie] = useState<boolean>(false)
  const [calculateLength, setCalculateLength] = useState<boolean>(false)
  const [calculateWeight, setCalculateWeight] = useState<boolean>(false)
  const [invoiceFiles, setInvoiceFiles] = useState<File[]>(stock.invoice)
  const [certificateFiles, setCertificateFiles] = useState<File[]>(
    stock.certificates,
  )
  const [warningMessage, setWarningMessage] = useState<string>('')

  const initialInvPercentage = new Array(stock.invoice.length).fill(100)
  const initialCertPercentage = new Array(stock.certificates.length).fill(100)

  const [invPercentage, setInvPercentage] =
    useState<number[]>(initialInvPercentage)
  const [certPercentage, setCertPercentage] = useState<number[]>(
    initialCertPercentage,
  )
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    setWarningMessage('')
  }, [stock, updateInOmie, calculateLength, calculateWeight])

  function getNewName(name: string): string {
    const stlCharacter = parseInt(name.charAt(name.length - 2)) //secondtolastCharacter
    const last4Characters = ` (${stlCharacter})`
    if (!isNaN(stlCharacter) && name.slice(-4) === last4Characters) {
      const nameStart = name.slice(0, name.length - 2)
      const newName = nameStart + [stlCharacter + 1] + ')'
      return newName
    } else {
      const newName = name + ' (1)'
      return newName
    }
  }

  const handleUploadInvoice = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files!)
    console.log(files)
    for (let i = 0; i < files.length; i++) {
      for (let j = 0; j < invoiceFiles.length; j++) {
        if (files[i].name === invoiceFiles[j].name) {
          const blob = files[i]
          const newFile = new File([blob], getNewName(files[i].name), {
            type: blob.type,
          })
          files.splice(i, 1, newFile)
        }
      }
    }
    setInvoiceFiles((prevInvoiceFiles) => [...prevInvoiceFiles, ...files])
    setStock((prevStock) => ({
      ...prevStock,
      invoice: [...prevStock.invoice, ...files],
    }))
    const progressArray = Array(files.length).fill(0)
    for (let k = 0; k < files.length; k++) {
      const formData = new FormData()
      formData.append('file', files[k])
      const xhr = new XMLHttpRequest()
      xhr.upload.addEventListener('progress', (e) =>
        ProgressHandler(e, k, progressArray, 'inv'),
      )
      xhr.open('POST', 'fileupload.php')
      xhr.send(formData)
    }
  }

  const handleUploadCertificates = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files!)
    for (let i = 0; i < files.length; i++) {
      for (let j = 0; j < certificateFiles.length; j++) {
        if (files[i].name === certificateFiles[j].name) {
          const blob = files[i]
          const newFile = new File([blob], getNewName(files[i].name), {
            type: blob.type,
          })
          files.splice(i, 1, newFile)
        }
      }
    }
    setCertificateFiles((prevCertificateFiles) => [
      ...prevCertificateFiles,
      ...files,
    ])
    setStock((prevStock) => ({
      ...prevStock,
      certificates: [...prevStock.certificates, ...files],
    }))
    const progressArray = Array(files.length).fill(0)
    for (let k = 0; k < files.length; k++) {
      const formData = new FormData()
      formData.append('file', files[k])
      const xhr = new XMLHttpRequest()
      xhr.upload.addEventListener('progress', (e) =>
        ProgressHandler(e, k, progressArray, 'cert'),
      )
      xhr.open('POST', 'fileupload.php')
      xhr.send(formData)
    }
  }

  const ProgressHandler = (
    e: ProgressEvent<XMLHttpRequestEventTarget>,
    index: number,
    progressArray: any[],
    type: string,
  ) => {
    const percent = (e.loaded / e.total) * 100
    progressArray[index] = percent.toFixed(0)
    if (type === 'inv') {
      const newPercentage = [...invPercentage, ...progressArray]
      setInvPercentage(newPercentage)
    } else {
      const newPercentage = [...certPercentage, ...progressArray]
      setCertPercentage(newPercentage)
    }
  }

  const handleInvDelete = (name: string, index: number) => {
    const newArray = [...invoiceFiles]
    const newPercentages = [...invPercentage]
    newArray.splice(index, 1)
    newPercentages.splice(index, 1)
    setInvoiceFiles(newArray)
    setInvPercentage(newPercentages)
  }

  const handleCertDelete = (name: string, index: number) => {
    const newArray = [...certificateFiles]
    const newPercentages = [...certPercentage]
    newArray.splice(index, 1)
    newPercentages.splice(index, 1)
    setCertificateFiles(newArray)
    setCertPercentage(newPercentages)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setStock({
      ...stock,
      [name]: value,
    })
  }

  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target
    switch (name) {
      case 'omie':
        setUpdateInOmie(!updateInOmie)
        break
      case 'calcLength':
        if (calculateWeight) {
          setCalculateWeight(false)
        }
        setCalculateLength(!calculateLength)
        break
      case 'calcWeight':
        if (calculateLength) {
          setCalculateLength(false)
        }
        setCalculateWeight(!calculateWeight)
        break
      default:
        console.log('Caminho inesperado ao ativar um switch toggle')
        break
    }
  }

  const handleDropdownClick = (value: string, field: string) => {
    setStock({
      ...stock,
      [field]: value,
    })
    setActiveMenu(0)
  }

  const previousPage = () => {
    setModalSection('secondCustomAdd')
  }

  const handleSubmit = () => {
    if (stock.code === '') {
      setWarningMessage(`O campo "Código" é obrigatório!`)
      return
    }
  
    if (updateInOmie) {
      // Validando os campos NCM e Número de Rastreamento
      if (stock.ncm === '') {
        setWarningMessage(`O campo "NCM" é obrigatório para atualização na Omie!`)
        return
      }
  
      if (stock.trackingNumber === '') {
        setWarningMessage(`O campo "Número de Rastreamento" é obrigatório para atualização na Omie!`)
        return
      }
  
      if (stock.measurementUnit == 'KG') {
        if (calculateWeight) {
          setWarningMessage(
            `A unidade está marcada como "KG", para atualizar na Omie ela tem que ser preenchida manualmente, não calculada!`
          )
          return
        } else if (stock.totalWeight === '') {
          setWarningMessage(
            `Para atualizar na Omie, é necessário preencher o campo "KG"!`
          )
          return
        } else if (stock.costPerKg === '') {
          setWarningMessage(
            `Para atualizar na Omie, é necessário preencher o campo "Custo por Kg"!`
          )
          return
        }
      } else if (stock.measurementUnit === 'MM') {
        if (calculateLength) {
          setWarningMessage(
            `A unidade está marcada como "MM", para atualizar na Omie ela tem que ser preenchida manualmente, não calculada!`
          )
          return
        } else if (stock.lengthInMm === '') {
          setWarningMessage(
            `Para atualizar na Omie, é necessário preencher o campo "MM"!`
          )
          return
        } else if (stock.costPerMm === '') {
          setWarningMessage(
            `Para atualizar na Omie, é necessário preencher o campo "Custo por Mm"!`
          )
          return
        }
      }
    }
  
    if (calculateLength) {
      if (stock.lengthInMm !== '') {
        setWarningMessage(
          `O comprimento já está preenchido, ele não pode ser calculado!`
        )
        return
      }
      const fieldsNeeded = [
        stock.totalWeight,
        stock.dimension1,
        stock.dimension2,
        stock.format,
        stock.density,
      ]
      const fieldsNames = [
        '"Peso", ',
        '"Dimensão 1", ',
        '"Dimensão 2", ',
        '"Formato", ',
        '"Densidade", ',
      ]
      let message =
        'Para calcular o comprimento, é necessário que os seguintes campos estejam preenchidos: '
      let block = false
      for (const i in fieldsNeeded) {
        if (fieldsNeeded[i] === '') {
          message += fieldsNames[i]
          block = true
        }
      }
      if (block) {
        console.log(message)
        message = message.slice(0, -1)
        message = message.slice(0, -1)
        message += '.'
        setWarningMessage(message)
        return
      }
    }
  
    if (calculateWeight) {
      if (stock.totalWeight !== '') {
        setWarningMessage(
          `O peso já está preenchido, ele não pode ser calculado!`
        )
        return
      }
      const fieldsNeeded = [
        stock.lengthInMm,
        stock.dimension1,
        stock.dimension2,
        stock.format,
        stock.density,
      ]
      const fieldsNames = [
        '"Comprimento", ',
        '"Dimensão 1", ',
        '"Dimensão 2", ',
        '"Formato", ',
        '"Densidade", ',
      ]
      let message =
        'Para calcular o peso, é necessário que os seguintes campos estejam preenchidos: '
      let block = false
      for (const i in fieldsNeeded) {
        if (fieldsNeeded[i] === '') {
          message += fieldsNames[i]
          block = true
        }
      }
      if (block) {
        message = message.slice(-2)
        message += '.'
        setWarningMessage(message)
        return
      }
    }
  
    handleSubmitForm()
  }
  

  const handleSubmitForm = () => {
    const formData = new FormData()
    formData.append('material', stock.material)
    formData.append('heatNumber', stock.heatNumber)
    formData.append('format', stock.format)
    formData.append('finishing', stock.finishing)
    formData.append('fabrication', stock.fabrication)
    formData.append('heatTreatment', stock.heatTreatment)
    formData.append('originCountry', stock.originCountry)
    formData.append('supplier', stock.supplier)
    formData.append('stockStreet', stock.stockStreet)
    formData.append('shelf', stock.shelf)
    formData.append('stockLocation', stock.stockLocation)
    formData.append('quantity', stock.quantity)
    formData.append('totalWeight', stock.totalWeight)
    formData.append('dimension1', stock.dimension1)
    formData.append('dimension2', stock.dimension2)
    formData.append('lengthInMm', stock.lengthInMm)
    formData.append('costPerKg', stock.costPerKg)
    formData.append('costPerMm', stock.costPerMm)
    formData.append('totalCost', stock.totalCost)
    formData.append('code', stock.code)
    formData.append('ncm', stock.ncm)
    formData.append('density', stock.density)
    formData.append('receivedDate', stock.receivedDate)
    formData.append('heatNumber', stock.heatNumber)
    formData.append('totalCmc', stock.totalCmc)
    formData.append('trackingNumber', stock.trackingNumber)
    formData.append('description', stock.description)
    formData.append('status', stock.stockStatus)
    formData.append('characteristic', stock.characteristic)
    formData.append('purchaseOrder', stock.purchaseOrder)
    formData.append('measurementUnit', stock.measurementUnit)
    formData.append('availableBalance', stock.availableBalance)
    formData.append('nf', stock.nf)
    formData.append('certificateNumber', stock.certificateNumber)
    // adicione todos os outros campos do formulário ao objeto FormData aqui
    stock.invoice.forEach((file) => {
      formData.append('invoice', file)
    })
    stock.certificates.forEach((file) => {
      formData.append('certificates', file)
    })
    if (itIsUpdate) stock.availableBalance = '0'

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/stock`, stock, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Update-in-omie': updateInOmie,
          'Weight-calculate': calculateWeight,
          'Length-calculate': calculateLength,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        // setLoadingMessage('Concluído !')
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      })
      .catch((err) => {
        // setLoading(false)
        console.error(err)
        // setLoadingMessage('Erro ao tentar carregar !')
      })
  }

  const ProgressBar: React.FC<ProgressBar> = (props) => {
    const fillerStyles = {
      width: `${props.completion}%`,
    }

    return (
      <ProgressContainer>
        <ProgressFill style={fillerStyles} />
      </ProgressContainer>
    )
  }

  const WarningBox = () => {
    return (
      <WarningDiv>
        <WarningText>{warningMessage}</WarningText>
      </WarningDiv>
    )
  }

  const fieldsArray: string[][] = [
    ['code', 'ncm'],
    ['trackingNumber', 'purchaseOrder'],
  ]

  const requiredFields = ['ncm', 'trackingNumber']

  const validateFields = (updateInOmie: boolean, formData: any) => {
    if (updateInOmie) {
      // Verifica se os campos obrigatórios estão preenchidos
      for (const field of requiredFields) {
        if (!formData[field]) {
          // Campo obrigatório não preenchido
          return `${field} é obrigatório!`;
        }
      }
    }
    return null;  // Caso todos os campos obrigatórios estejam preenchidos
  };

  // Verifica se todos os campos obrigatórios foram preenchidos, incluindo 'code' que é sempre obrigatório
const allRequiredFieldsFilled = requiredFields.every((field) => {
  return stock[field as keyof StockInterface]; // Verifica se o valor do campo está preenchido
}) && stock['code']; // Garante que 'code' seja obrigatório

  const switches: string[] = ['omie', 'calcLength', 'calcWeight']
  const switchesText: string[] = [
    'Atualizar produtos na Omie',
    'Calcular comprimentos',
    'Calcular pesos',
  ]
  const switchValues: boolean[] = [
    updateInOmie,
    calculateLength,
    calculateWeight,
  ]

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>
          {itIsUpdate ? 'Editar Estoque' : 'Adicionar Estoque'}
        </HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <ProgressBarDiv>
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
      </ProgressBarDiv>
      {fieldsArray.map((inputRow, rowIndex) => (
  <InputRowDiv key={rowIndex}>
    {inputRow.map((stockField: string, colIndex) => {
      // Determina se o campo é obrigatório, incluindo 'code' que é sempre obrigatório
      const isRequired = requiredFields.includes(stockField) || stockField === 'code'; // 'code' é sempre obrigatório
      const hasError = errors[stockField]; // Verifica se há erro para esse campo
      const isFieldEmpty = !stock[stockField as keyof StockInterface]; // Verifica se o campo está vazio

      return (
        <InputDiv key={colIndex}>
          {activeMenu == rowIndex * 3 + colIndex + 1 ? (
            <StockDropdown
              text={stock[stockField as keyof StockInterface]}
              field={stockField}
              onChange={(value) => {
                handleDropdownClick(value, stockField);
              }}
            />
          ) : null}
          <InputLabel htmlFor={stockField}>
            {fieldsToHeaders[stockField as keyof FieldsToHeaders]}
            {(stockField === 'code' || (updateInOmie && isRequired)) && (
              <Info size={15} style={{marginLeft:5}} color={`${!stock[stockField as keyof StockInterface] ? 'red' : 'gray'}`}/>
          )}
          </InputLabel>
          <Input
            placeholder="Digite aqui"
            name={stockField}
            value={stock[stockField as keyof StockInterface]}
            onFocus={() => setActiveMenu(rowIndex * 3 + colIndex + 1)}
            onBlur={() => setActiveMenu(0)}
            onChange={handleChange}
            autoComplete="off"
            className={
              stockField === 'code' &&
              warningMessage === '!O campo "código" é obrigatório'
                ? 'redBorder'
                : ''
            }
          />
        </InputDiv>
      );
    })}
  </InputRowDiv>
))}



      <SwitchesDiv>
        {switches.map((field, index) => (
          <SwitchDiv key={field}>
            <SwitchLabel htmlFor={field}>{switchesText[index]}</SwitchLabel>
            <SwitchBox>
              <SwitchInput
                type='checkbox'
                name={field}
                checked={switchValues[index]}
                onChange={handleSwitchToggle}
              />
              <SwitchSlider className='slider'></SwitchSlider>
            </SwitchBox>
          </SwitchDiv>
        ))}
      </SwitchesDiv>
      <FilesDiv>
        <FileBlockDiv>
          <FileHeaderText>Nota fiscal</FileHeaderText>
          {invoiceFiles.length === 0 ? (
            <FileInputDiv>
              <FileInputLabel htmlFor='invoice'>
                Procurar
                <FileInput
                  type='file'
                  id='invoice'
                  name='invoice'
                  multiple
                  onChange={handleUploadInvoice}
                />
              </FileInputLabel>
              <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
              <FileSecondText>
                Apenas arquivos .pdf de no máximo 10mb
              </FileSecondText>
            </FileInputDiv>
          ) : (
            <span>
              <FilesInfoDiv>
                {invoiceFiles.map((file, index) => (
                  <FileInfoDiv key={file.name}>
                    <FileInfoImg src={fileIcon} alt='File icon' />
                    <FileMiddleDiv>
                      <FileUpperMiddleDiv>
                        <FileName>{file.name}</FileName>
                        <FilePercentage>{invPercentage[index]}%</FilePercentage>
                      </FileUpperMiddleDiv>
                      <ProgressBar completion={invPercentage[index]} />
                    </FileMiddleDiv>
                    <FileInfoCancelImg
                      src={cancelIcon}
                      alt='File icon'
                      onClick={() => handleInvDelete(file.name, index)}
                    />
                  </FileInfoDiv>
                ))}
              </FilesInfoDiv>
              <FileInputLabel htmlFor='invoice' className='down'>
                Procurar
                <FileInput
                  type='file'
                  id='invoice'
                  name='invoice'
                  multiple
                  onChange={handleUploadInvoice}
                />
              </FileInputLabel>
            </span>
          )}
        </FileBlockDiv>
        <FileBlockDiv>
          <FileHeaderText>Certificados</FileHeaderText>
          {certificateFiles.length === 0 ? (
            <FileInputDiv>
              <FileInputLabel htmlFor='certificates'>
                Procurar
                <FileInput
                  type='file'
                  id='certificates'
                  name='certificates'
                  multiple
                  onChange={handleUploadCertificates}
                />
              </FileInputLabel>
              <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
              <FileSecondText>
                Apenas arquivos .pdf de no máximo 10mb
              </FileSecondText>
            </FileInputDiv>
          ) : (
            <span>
              <FilesInfoDiv>
                {certificateFiles.map((file, index) => (
                  <FileInfoDiv key={file.name}>
                    <FileInfoImg src={fileIcon} alt='File icon' />
                    <FileMiddleDiv>
                      <FileUpperMiddleDiv>
                        <FileName>{file.name}</FileName>
                        <FilePercentage>
                          {certPercentage[index]}%
                        </FilePercentage>
                      </FileUpperMiddleDiv>
                      <ProgressBar completion={certPercentage[index]} />
                    </FileMiddleDiv>
                    <FileInfoCancelImg
                      src={cancelIcon}
                      alt='File icon'
                      onClick={() => handleCertDelete(file.name, index)}
                    />
                  </FileInfoDiv>
                ))}
              </FilesInfoDiv>
              <FileInputLabel htmlFor='certificate' className='down'>
                Procurar
                <FileInput
                  type='file'
                  id='certificate'
                  name='certificate'
                  multiple
                  onChange={handleUploadCertificates}
                />
              </FileInputLabel>
            </span>
          )}
        </FileBlockDiv>
      </FilesDiv>
      <ButtonsDiv>
        <WarningBox />
        <PreviousButtonDiv onClick={previousPage}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>
        <NextButtonDiv
          onClick={() => handleSubmit()}
          className={warningMessage !== '' ? 'disabled' : ''}
        >
          <NextButtonImage src={diskIcon} alt='Right arrow icon' />
          <NextButtonText>Salvar</NextButtonText>
        </NextButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default ThirdCustomAddPage
